package ru.playa.sce.dto

class AccountPrivilege(
        val objectType: ApplicableType,
        val privileges: Array<String>
)